import React from "react"
import BackButton from "../components/controls/BackButton"
import BackLink from "../components/controls/BackLink"
import NewUserForm from "../components/new-user/NewUserForm"
import { UserRole } from "../types/user"

interface Props {
  backPath: string
  userRole: UserRole
}

const NewUserPage = ({ backPath, userRole }: Props): JSX.Element => {

  return (
    <main className="PageSection PageSection--offset-top-extra u-mt-lg">
      <div className="PageSection-content PageSection-content--flex">
        <div className="flex-col-2 d-n-sm-none">
          {backPath && <BackLink className="u-min-w-88" href={backPath}/>}
          {!backPath && <BackButton className="u-min-w-88"/>}
        </div>
        <div className="Form flex-auto">
          <NewUserForm userRole={userRole}/>
        </div>
      </div>
    </main>
  )
}

export default NewUserPage
